(function () {
    'use strict';

    $(document).ready(function() {
        $(".loadmore").hover(function(){
            $(".icon-load").toggleClass("blue");
        });
    });

})();